import ProductAttributeValue from 'Component/ProductAttributeValue';
import ProductConfigurableAttributeDropdown from 'Component/ProductConfigurableAttributeDropdown';
import {
    ProductConfigurableAttributes as SourceProductConfigurableAttributes
} from 'SourceComponent/ProductConfigurableAttributes/ProductConfigurableAttributes.component';
import { getVariantIndex } from 'Util/Product';

import './ProductConfigurableAttributes.override.style';

/** @namespace Elganso/Component/ProductConfigurableAttributes/Component */
export class ProductConfigurableAttributesComponent extends SourceProductConfigurableAttributes {
    renderSwatch(option, isUnselected) {
        const {
            handleShakeAnimationEnd
        } = this.props;
        const { attribute_values, attribute_code } = option;

        return (
            <div
              block="ProductConfigurableAttributes"
              elem="SwatchList"
              mods={ { isUnselected, attribute_code } }
              key={ attribute_code }
              onAnimationEnd={ handleShakeAnimationEnd }
            >
                { attribute_values.map((attribute_value) => (
                    this.renderConfigurableAttributeValue({ ...option, attribute_value })
                )) }
            </div>
        );
    }

    renderDropdown(option, isUnselected) {
        const {
            updateConfigurableVariant,
            getIsConfigurableAttributeAvailable,
            parameters,
            handleShakeAnimationEnd,
            product
        } = this.props;

        return (
            <ProductConfigurableAttributeDropdown
              handleShakeAnimationEnd={ handleShakeAnimationEnd }
              isUnselected={ isUnselected }
              option={ option }
              updateConfigurableVariant={ updateConfigurableVariant }
              getIsConfigurableAttributeAvailable={ getIsConfigurableAttributeAvailable }
              parameters={ parameters }
              product={ product }
            />
        );
    }

    renderConfigurableAttributeValue(attribute) {
        const {
            handleOptionClick,
            getLink,
            showProductAttributeAsLink,
            inStock,
            product: { variants },
            product,
            checkIsSelected,
            parameters
        } = this.props;

        const { attribute_value, attribute_code } = attribute;

        // No creamos las tallas que no tengamos disponibles con los parametros actuales
        if (attribute_code === 'size') {
            const newParameter = { ...parameters };
            newParameter.size = attribute.attribute_value;

            // Comprobamos primero por si tuvieramos algun problema con los colores
            if ('color' in parameters) {
                if (product?.configurable_options?.color?.attribute_options) {
                    const product_colors = Object.keys(product.configurable_options.color.attribute_options);

                    // COMPROBAR PARAMETRO COLOR CORRESPONDE A UNO DE LOS COLORES DEL PRODUCTO
                    if (!product_colors.find((e) => e === parameters.color)) {
                        newParameter.color = product_colors[0];
                    }
                } else {
                    const product_colors = Object.keys(product.attributes.color.attribute_options);

                    // COMPROBAR PARAMETRO COLOR CORRESPONDE A UNO DE LOS COLORES DEL PRODUCTO
                    if (!product_colors.find((e) => e === parameters.color)) {
                        newParameter.color = product_colors[0];
                    }
                }
            }

            const variantIndex = getVariantIndex(variants, newParameter);

            if (variantIndex === -1) {
                return null;
            }
        }

        return (
            <ProductAttributeValue
              key={ attribute_value }
              attribute={ attribute }
              isSelected={ checkIsSelected(attribute) }
              isAvailable={ inStock }
              onClick={ handleOptionClick }
              getLink={ getLink }
              showProductAttributeAsLink={ showProductAttributeAsLink }
              product={ product }
              YBParameters={ parameters }
            />
        );
    }

    getIsColorLight(hex) {
        if (hex != null) {
            const color = (hex.charAt(0) === '#') ? hex.substring(1, 7) : hex;
            const r = parseInt(color.substring(0, 2), 16); // hexToR
            const g = parseInt(color.substring(2, 4), 16); // hexToG
            const b = parseInt(color.substring(4, 6), 16); // hexToB

            return ((r * 0.299) + (g * 0.587) + (b * 0.114)) > 186;
        }

        return false;
    }

    renderColorValue(color, label) {
        const isLight = this.getIsColorLight(color);

        const style = {
            '--option-background-color': color,
            '--option-border-color': isLight ? '#606060' : color,
            '--option-check-mark-background': isLight ? '#000' : '#fff',
            '--option-is-selected': 0
        };

        return (
            <data
              block="ProductAttributeValue"
              elem="Color"
              value={ label }
              title={ label }
              style={ style }
            />
        );
    }

    renderConfigurableAttributes() {
        const {
            configurable_options,
            inStock,
            addToCartTriggeredWithError,
            parameters,
            product,
            clickColorButton,
            showColors
        } = this.props;

        return Object.values(configurable_options).map((option) => {
            const {
                attribute_code,
                attribute_options,
                attribute_values,
                attribute_id
            } = option;
            const isUnselected = addToCartTriggeredWithError ? !parameters[attribute_code] : null;
            const [{ swatch_data }] = attribute_options ? Object.values(attribute_options) : [{}];
            const isSwatch = !!swatch_data;

            if (!inStock && !isSwatch) {
                return null;
            }

            if (attribute_code === 'color') {
                const default_color = product.attributes.default_color.attribute_value ?? null;
                const actual_color = parameters[attribute_code] ?? null;

                const opt = attribute_options[actual_color !== null ? actual_color : default_color]?.swatch_data;

                return (
                    <div key={ attribute_id } className={ attribute_code + (showColors ? ' show-color' : '') }>
                        { isSwatch ? this.renderSwatch(option, isUnselected) : this.renderDropdown(option, isUnselected) }
                        { attribute_values.length > 1
                            ? (
                                <span
                                  className="plus-colors"
                                  onClick={ clickColorButton }
                                  onKeyDown={ clickColorButton }
                                >
                                    <span className="default-color">{ this.renderColorValue(opt?.value, opt?.label) }</span>
                                    { !showColors
                                        ? (`+${attribute_values.length - 1}`)
                                        : '>' }
                                </span>
                            ) : null }
                    </div>
                );
            }

            return (
                <div key={ attribute_id } className={ attribute_code + (product?.yeboyebo_carrito_promociones_precio ? ' special-price' : '') }>
                    { isSwatch ? this.renderSwatch(option, isUnselected) : this.renderDropdown(option, isUnselected) }
                </div>
            );
        });
    }

    render() {
        const { isReady, mix } = this.props;

        return (
            <div
              block="ProductConfigurableAttributes"
              mods={ { isLoading: !isReady } }
              mix={ mix }
            >
                { isReady ? this.renderConfigurableAttributes() : null }
            </div>
        );
    }
}

export default ProductConfigurableAttributesComponent;
